import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Grid } from "@material-ui/core";
import FilledTextField from "./FilledTextField";

export const Conversion = ({
  conversionFunction,
  validateInput,
  validateOutput,
  inputFieldProps,
  outputFieldProps,
  convertButtonProps,
  displayInputField,
  displayOutputField,
  parentInput,
  exportOutputFunction,
  resetInputOnConvert,
  testIds,
}) => {
  const { t } = useTranslation();

  const [input, setInput] = useState("");
  const [currentInputHelperText, setCurrentInputHelperText] = useState("");
  const [inputErrorStatus, setInputErrorStatus] = useState(false);

  const [disableButton, setDisableButton] = useState(true);

  const [output, setOutput] = useState("");
  const [currentOutputHelperText, setCurrentOutputHelperText] = useState("");
  const [outputErrorStatus, setOutputErrorStatus] = useState(false);

  const handleClick = () => {
    setOutput(conversionFunction(input));
    if (resetInputOnConvert) setInput("");
  };
  useEffect(() => {
    setInput(parentInput);
  }, [parentInput]);

  useEffect(() => {
    if (!validateInput(input) && input !== "") {
      setInputErrorStatus(true);
      setCurrentInputHelperText(inputFieldProps.errorhelpertext || "");
    } else {
      setInputErrorStatus(false);
      setCurrentInputHelperText("");
      setDisableButton(false);
    }
  }, [input]);

  useEffect(() => {
    if (input === "") {
      setDisableButton(true);
    } else if (inputErrorStatus) {
      setDisableButton(true);
    } else {
      setDisableButton(false);
    }
  }, [input, inputErrorStatus]);

  useEffect(() => {
    if (!validateOutput(output)) {
      setOutputErrorStatus(true);
      setCurrentOutputHelperText(outputFieldProps.errorhelpertext || "");
    } else {
      setOutputErrorStatus(false);
      setCurrentOutputHelperText("");
    }
    exportOutputFunction(output);
  }, [output]);

  return (
    <Grid>
      <Grid style={{ display: "flex", alignItems: "center" }}>
        {displayInputField && (
          <Grid style={{ width: "66%" }}>
            <FilledTextField
              value={input}
              onChange={(e) => setInput(e.target.value)}
              label={t("Components.Conversion.Input")}
              error={inputErrorStatus}
              helperText={currentInputHelperText}
              underlineColor="white"
              testIds={{
                input: testIds.input,
              }}
              {...inputFieldProps}
            />
          </Grid>
        )}
        <Grid>
          <Button
            data-testid={testIds.convertButton}
            onClick={handleClick}
            disabled={disableButton}
            style={{
              borderStyle: "solid",
              borderColor: "white",
              borderWidth: "1px",
              marginLeft: "33%",
            }}
            {...convertButtonProps}
          >
            {convertButtonProps.label || t("Components.Conversion.Convert")}
          </Button>
        </Grid>
      </Grid>
      <Grid>
        {displayOutputField && (
          <Grid>
            <FilledTextField
              value={output}
              label={t("Components.Conversion.Output")}
              error={outputErrorStatus}
              helperText={currentOutputHelperText}
              underlineColor="white"
              testIds={{
                input: testIds.input,
              }}
              {...outputFieldProps}
            />
          </Grid>
        )}
      </Grid>
    </Grid>
  );
};
Conversion.propTypes = {
  conversionFunction: PropTypes.func.isRequired,
  validateInput: PropTypes.func,
  validateOutput: PropTypes.func,
  inputFieldProps: PropTypes.object,
  outputFieldProps: PropTypes.object,
  convertButtonProps: PropTypes.object,
  displayInputField: PropTypes.bool,
  displayOutputField: PropTypes.bool,
  parentInput: PropTypes.any,
  exportOutputFunction: PropTypes.func,
  resetInputOnConvert: PropTypes.bool,
  testIds: PropTypes.object,
};

Conversion.defaultProps = {
  validateInput: (input) => input,
  validateOutput: (output) => output,
  inputFieldProps: {},
  outputFieldProps: {},
  convertButtonProps: {},
  displayInputField: true,
  displayOutputField: true,
  parentInput: "",
  exportOutputFunction: () => {},
  resetInputOnConvert: false,
  testIds: {},
};

export default Conversion;
